module.exports = __webpack_public_path__ + "static/paper2-f66a653312df8608724fc4677dc8cde0.png";